import { UserAccount } from "services";
import {
    mapCounty,
    mapModules,
    mapNotifications,
    mapSubscriptions,
    mapUserRole,
} from "./mappingUtils";

export const mapUserAccount = (userAccount: UserAccount) => {
    const county = mapCounty(userAccount.countyId);
    const userRole = mapUserRole(userAccount.roleType);
    const notifications = mapNotifications(userAccount.notificationType);
    const subscriptions = mapSubscriptions(userAccount.infoType);
    const modules = mapModules(userAccount.moduleName);

    return {
        uid: userAccount.uid ?? "",
        mibpg: userAccount.mibpg ?? "",
        email: userAccount.email ?? "",
        username: userAccount.username ?? "",
        legalEntityName: userAccount.legalEntityName ?? "",
        firstName: userAccount.firstName ?? "",
        lastName: userAccount.lastName ?? "",
        street: userAccount.street ?? "",
        streetNumber: userAccount.streetNumber ?? "",
        postalNumber: userAccount.postalNumber ?? "",
        city: userAccount.city ?? "",
        country: userAccount.country ?? "",
        mobileNumber: userAccount.mobileNumber ?? "",
        additionalMobileNumber: userAccount.additionalMobileNumber ?? "",
        county: county?.label ?? "",
        roleType: userAccount.roleType,
        userRole,
        notificationType: notifications,
        infoType: subscriptions,
        moduleName: modules,
        isActive: userAccount.isActive,
    };
};

export const mapUserName = (user: Partial<UserAccount>) => {
    if (!user) return "";

    const name = `${user.firstName} ${user.lastName}`.trim();
    const email = user.email ? `(${user.email.trim()})` : "";
    const userRole = user.roleType ? mapUserRole(user.roleType)?.label : "";

    return [userRole, name, email].filter(Boolean).join(" - ");
};

export type MappedUserAccount = ReturnType<typeof mapUserAccount>;
